var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.bannerVisible),expression:"bannerVisible"}],staticClass:"banner-component",style:({
		'background-color': _vm.currentBannerType.backgroundColor,
		color: _vm.currentBannerType.textColor,
	})},[_c('div',{staticClass:"message"},[_vm._t("default")],2),(_vm.showCloseButton)?_c('i',{attrs:{"lass":"fas fa-times close-icon"},on:{"click":_vm.closeBanner}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }